<app-breadcrumb [title]="'Wishlist'" [breadcrumb]="'Wishlist'"></app-breadcrumb>
<!--section start-->
<section class="wishlist-section section-b-space" id="wishlist">
  <div class="container">
    <div class="col-md-12 empty-cart-cls text-center" *ngIf='Fprod==null || Fprod.length==0'>
      <img src="assets/images/empty-wishlist.png" alt="Empty cart" title="Emprt cart">
      <h3 class="mt-4"><b>Wishlist is Empty</b></h3>
      <h4>Explore more shortlist some items.</h4>
    </div>

    <!-- old -->

    <div class="row pcview" *ngIf='ecomproducts != null' id="table">
      <div class="col-sm-12">
        <table class="table cart-table table-responsive-xs" *ngIf='ecomproducts.length > 0'>
          <thead>
            <tr class="table-head">
              <th scope="col">image</th>
              <th scope="col">product name</th>
              <th scope="col">price</th>
              <th scope="col">action</th>
            </tr>
          </thead>
          <tbody *ngFor="let product of ecomproducts; let i=index">
            <tr>
              <td>
                <a [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                  <img [src]="product.img" [alt]="product.img">
                </a>
              </td>
              <td>
                <a [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">{{ product.pname |
                  titlecase }}</a>
                <div class="mobile-cart-content row">
                  <div class="col">
                  </div>
                  <div class="col">
                    <h2 class="td-color">
                      {{ product.pri }}
                    </h2>
                  </div>
                  <div class="col">
                    <h2 class="td-color">
                      <a href="javascript:void(0)" (click)="removeItem(product)" class="icon me-1">
                        <i class="ti-close"></i>
                      </a>
                      <a [routerLink]="['/shop/cart']" (click)="addToCart(product)" class="cart">
                        <i class="ti-shopping-cart"></i>
                      </a>
                    </h2>
                  </div>
                </div>
              </td>
              <td>
                <h4>
                  ₹ {{ product.pri }}
                </h4>
              </td>
              <td>
                <a href="javascript:void(0)" (click)="removefav(i)" class="icon me-3">
                  <i class="ti-close"></i>
                </a>
                <!-- <a href="javascript:void(0)" (click)="addToCart(product)" class="cart">
                    <i class="ti-shopping-cart"></i>
                  </a> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- new -->

    <div class="row mobileview" style="margin-bottom: 20px;" id="mobileview">
      <div class="col-6" *ngFor="let product of ecomproducts; let i=index" style="padding: 10px;">

        <div class="img-wrapper">
          <div class="cart-info cart-wrap">
            <a href="javascript:void(0)" title="REMOVE" (click)="removefav(i)">
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>
          </div>
          <div class="lable-block">
          </div>
          <div class="front">
            <a [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
              <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                [lazyLoad]="ImageSrc ? ImageSrc : product?.img" class="img-fluid lazy-loading"
                alt="{{ product?.img }}" />

            </a>
          </div>
          <div class="back" *ngIf="onHowerChangeImage">
            <a [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
              <img [src]="ImageSrc ? ImageSrc : product.img" class="img-fluid lazy-loading" alt="{{ product?.img }}">
            </a>
          </div>


        </div>
        <div class="product-detail">
          <div>
            <bar-rating *ngIf="product.avg_star > 0" [rate]="product.avg_star" [readOnly]="true"></bar-rating>
            <a [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
              <h6>{{ product?.pname | titlecase }}</h6>
            </a>

            <h4>
              <strong class="kg" *ngIf="product?.cid > 0">1.5 KG
                -</strong> ₹ {{ product?.pri}}
            </h4>

          </div>
        </div>
      </div>

    </div>


    <div class="row wishlist-buttons" *ngIf='products.length' id="nav">
      <div class="col-12">
        <a [routerLink]="['/shop/collection/left/sidebar']" class="btn btn-solid">continue shopping</a>
        <a [routerLink]="['/shop/checkout']" class="btn btn-solid">check out</a>
      </div>
    </div>
  </div>
</section>
<!--section end-->